import React, { useEffect, useState } from "react";
import "../../Package/PackageDetails.css";
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';
import './../Enquiry-Details/Enquiry-from.css';
import { Backdrop, Button, CircularProgress } from "@mui/material";
import toast, { Toaster } from 'react-hot-toast';
import environment from "../../../environment/environment";
import { Link, useNavigate, useParams } from "react-router-dom"
import SignIn from "../../../components/SignInComponent/SignIn";
import HeaderComponent from "../../../components/Header/Header";
import PhoneInput from 'react-phone-input-2';

function Enquiryform(props) {

  const [scrollFormTop, setScrollFormTop] = useState(0); // Track scroll position
  const [isFormFixed, setIsFormFixed] = useState(false);
  const [packageItemList, setPackageItemList] = useState('');
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [travelDate, setTravelDate] = useState('');
  const [travelCount, setTravelCount] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const navigate = useNavigate()
  // Validation error states
  const [errors, setErrors] = useState({});
  const [isModelSign, setIsModelSign] = useState(false);

  useEffect(() => {
    setPackageItemList(props?.packageItemList);
  }, [props]);

  // Validate fields when the form is submitted
  const validateForm = () => {
    const newErrors = {};

    if (!fullName.trim()) newErrors.fullName = 'Full Name is required';

    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = 'Valid Email is required';
    }

    if (!mobileNo.trim()) {
      newErrors.mobileNo = 'Mobile No. is required';
    } else if (!/^\d{10}$/.test(mobileNo)) {
      newErrors.mobileNo = 'Mobile No. must be exactly 10 digits';
    }

    if (!travelDate) newErrors.travelDate = 'Travel Date is required';
    if (!travelCount) newErrors.travelCount = 'Traveller Count is required';
    if (!message.trim()) newErrors.message = 'Message is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle change and remove error when user types
  const handleChange = (field, value) => {
    // Update the field value
    switch (field) {
      case 'fullName':
        setFullName(value);
        break;
      case 'email':
        setEmail(value);
        break;
      case 'mobileNo':
        setMobileNo(value);
        break;
      case 'travelDate':
        setTravelDate(value);
        break;
      case 'travelCount':
        setTravelCount(value);
        break;
      case 'message':
        setMessage(value);
        break;
      default:
        break;
    }

    // Remove error for the field if it is corrected
    if (errors[field]) {
      setErrors((prevErrors) => ({ ...prevErrors, [field]: '' }));
    }
  };
  const handleBookOnline = (event) => {
    let accessToken = localStorage.getItem('token');
    if (accessToken) {//it will check this condition 
      navigate('/booking', { state: { packageData: props?.packageItemList } });
    } else {
      setIsModelSign(true)
    }

  }
  const handleClose = (data) => {
    if (!data) {
      setIsModelSign(false);
    }
    // handleClearForm()
  };
  const onSignInUser = (data) => {
    setUserDetails(data);
    // setIsLoggedIn(true)
  }
  const sendEnquiry = () => {
    if (!validateForm()) {
      // toast.error('Please Enter Valid Details To Connect With An Experts!')
      return;  // Do not proceed if validation fails
    }
    const requestBody = {
      "fullName": fullName,
      "email": email,
      "phoneNumber": mobileNo,
      "travelDate": travelDate,
      "travellerCount": travelCount,
      "message": message,
      "type": "website"
    };

    setLoading(true);
    axios({
      url: `${environment.config.apiBaseUrl}enquiry/createEnquiryDeatils`,
      method: "POST",
      headers: {
        authorization: "your token comes here",
      },
      data: requestBody
    })
      .then((res) => {
        setLoading(false);
        if (res && res.data) {
          // toast.success('Your Equiry Details Added Successfully Our Team Will Contact You Soon!')
        }
      })
      .catch(() => { setLoading(false); });

    // Reset form fields after submission
    setFullName('');
    setEmail('');
    setMessage('');
    setTravelCount('');
    setTravelDate('');
    setMessage('');
    setMobileNo('');
  };
  // Scroll event listener to detect when to fix the form
  useEffect(() => {
    // const cardmt = document.getElementsByClassName('cardmt');
    const trip = document.getElementById('end-trip');
    const handleScroll = () => {
      if (window.scrollY >= 1500) {
        setIsFormFixed(true);
        // cardmt.style.top = '10%';      
      } else {
        // cardmt.style.top = '';
        setIsFormFixed(false);

      }
      if (trip) {
        setIsFormFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <>
      <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Toaster
        position="top-right"
        reverseOrder={false}
      />
      <div
        className="col-md-4  card-display cardmt"
        id="form-section"
        style={{
          position: 'sticky',
          top: 130,
          zIndex: 999,
          width: '100%', // Ensure proper width
          marginBottom: 25,
        }}
      >
        <div className=" card enquiryForm ">
          <div className="card-body mt-3">
            <div className="Package-title">
              {packageItemList?.packageName}
            </div>
            <div className="col display-package-prices-days">
              <p className="card-text">
                <b className="me-2 package-title-prices">
                  INR {packageItemList?.packageWithDiscountPrices ? new Intl.NumberFormat('en-IN').format(packageItemList.packageWithDiscountPrices) : 0}
                </b>
                <span className="package-price-decoration-details me-1">
                  INR {packageItemList?.packagePrices ? new Intl.NumberFormat('en-IN').format(packageItemList.packagePrices) : 0}
                </span>
                <span className="title-prices">
                  INR {packageItemList?.savePrices ? new Intl.NumberFormat('en-IN').format(packageItemList.savePrices) : 0}
                </span>
              </p>
            </div>
            <form className="mt-1">
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className={`form-control enquiry-input ${errors.fullName ? 'is-invalid' : ''}`}
                  placeholder="Full Name"
                  value={fullName}
                  onChange={(e) => handleChange('fullName', e.target.value)}
                />
                <label>Full Name *</label>
                {errors.fullName && <div className="invalid-feedback">{errors.fullName}</div>}
              </div>
              <div className="form-floating mb-3">
                <input
                  type="email"
                  className={`form-control enquiry-input ${errors.email ? 'is-invalid' : ''}`}
                  placeholder="name@example.com"
                  value={email}
                  onChange={(e) => handleChange('email', e.target.value)}
                />
                <label>Email* </label>
                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
              </div>
              {/* <div className="form-floating mb-3">
                <input
                  type="text"
                  className={`form-control enquiry-input ${errors.mobileNo ? 'is-invalid' : ''}`}
                  placeholder="+91 xxx xxxx xxx"
                  value={mobileNo}
                  pattern="\d{10}"
                  minLength={10}
                  maxLength={10}
                  onChange={(e) => handleChange('mobileNo', e.target.value)}
                />
                <label>Mobile No.*</label>
                {errors.mobileNo && <div className="invalid-feedback">{errors.mobileNo}</div>}
              </div> */}
              <div className="form-floating mb-3">
                <PhoneInput
                  country={'in'}
                  value={mobileNo}
                  onChange={(value) => handleChange('mobileNo', value)}
                  inputStyle={{ width: '100%', height: '55px' }}
                  countryCodeEditable={false}
                />
                {errors.mobileNo && (
                  <div className="invalid-feedback" style={{ display: 'block' }}>
                    {errors.mobileNo}
                  </div>
                )}                 </div>
              <div className="row align-self-center">
                <div className="col-md-6 mt-1">
                  <div className="form-floating mb-3">
                    <input
                      type="date"
                      className={`form-control enquiry-input ${errors.travelDate ? 'is-invalid' : ''}`}
                      placeholder="Travel Date"
                      value={travelDate}
                      min={new Date().toISOString().split('T')[0]}
                      max={new Date(new Date().getFullYear() + 1, 11, 31).toISOString().split('T')[0]}
                      onChange={(e) => handleChange('travelDate', e.target.value)}
                    />
                    <label>Travel Date*</label>
                    {errors.travelDate && <div className="invalid-feedback">{errors.travelDate}</div>}
                  </div>
                </div>
                <div className="col-md-6 mt-1">
                  <div className="form-floating mb-3">
                    <input
                      type="number"
                      className={`form-control enquiry-input ${errors.travelCount ? 'is-invalid' : ''}`}
                      placeholder="Traveller Count"
                      value={travelCount}
                      onChange={(e) => handleChange('travelCount', e.target.value)}
                      min={1}
                      max={5}
                    />
                    <label>Traveller Count*</label>
                    {errors.travelCount && <div className="invalid-feedback">{errors.travelCount}</div>}
                  </div>
                </div>
              </div>
              <div className="form-floating mb-3">
                <textarea
                  className={`form-control enquiry-input ${errors.message ? 'is-invalid' : ''}`}
                  placeholder="Message"
                  value={message}
                  rows={4}
                  onChange={(e) => handleChange('message', e.target.value)}
                  style={{ minHeight: '100px' }}
                />
                <label className="message-placeholder">Your Requirements *</label>
                {errors.message && <div className="invalid-feedback">{errors.message}</div>}
              </div>
            </form>
            <div className="col button-display-line d-flex flex-row gap-2">
              <button
                type="button"
                className="btn btn-color bt-width"
                onClick={sendEnquiry}
              >
                Send Enquiry
              </button>
              <Button fullWidth type="submit" variant="contained" style={{ backgroundColor: '#fff099', color: '#2d2b29', height: '50px', fontWeight: 600, textTransform: 'capitalize' }} onClick={handleBookOnline}>Book Online</Button>
            </div>
          </div>
        </div>
        <div className="d-none">
          <HeaderComponent userDetails={userDetails}></HeaderComponent>
        </div>
        {
          isModelSign && (
            <div>
              <SignIn isModelSign={isModelSign} closePopup={handleClose} userDetais={onSignInUser}

                isBookOnline={true} packageItemList={packageItemList}></SignIn>

            </div>
          )
        }
      </div>
    </>
  );

}

export default Enquiryform;


